import { FormField, Dealer } from "./Form";

export const errorOrder = [
  "Ime",
  "Prezime",
  "Email adresa",
  "Telefonski broj",
  "Grad",
  "Poštanski broj",
  "Model vozila",
  "newsletter",
  "analyticsConsent",
  "privacyPolicy",
  "newsletter2",
  "analyticsConsent2",
  "privacyPolicy2",
];

export const fields1: FormField[] = [
  { name: "Ime", placeholder: "Unesite svoje ime", required: true },
  { name: "Prezime", placeholder: "Unesite svoje prezime", required: true },
  {
    name: "Email adresa",
    placeholder: "Unesite svoju email adresu",
    required: true,
    type: "email",
  },
];

export const conditionFields1 = [
  {
    id: "consent",
    required: true,
    content: (
      <>
        Potvrđujem da sam upoznat s{" "}
        <a
          href="https://www.jeep.com/hr/pravne-obavjesti.html"
          className="underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Izjavom o zaštiti osobnih podataka
        </a>{" "}
        te da će u svrhu obrade zahtjeva koji sam naveo na ovom obrascu mojim
        osobnim podacima upravljati tvrtka AUTOCOMMERCE HRVATSKA d.o.o i
        odabrani ovlašteni distributer/serviser. Svoju suglasnost mogu povući u
        bilo kojem trenutku.
      </>
    ),
  },
];

export const conditionFields2 = [
  {
    id: "consent",
    required: true,
    content: (
      <>
        Slanje ponuda i obavijesti o proizvodima i uslugama (newsletter). U
        svakom trenutku se možete odjaviti klikom na "Odjava" poveznicu koja se
        nalazi u podnožju svakog našeg newslettera ili pismenim putem na
        AUTOCOMMERCE HRVATSKA d.o.o, Kovinska 5, 10000 Zagreb. Za više
        informacija molimo pročitajte
        <a
          href="https://www.jeep.com/hr/pravne-obavjesti.html"
          className="underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          {" "}
          IZJAVU O ZAŠTITI PODATAKA.
        </a>
      </>
    ),
  },
];

export const fields2: FormField[] = [
  { name: "Ime", placeholder: "Unesite svoje ime", required: true },
  { name: "Prezime", placeholder: "Unesite svoje prezime", required: true },
  {
    name: "Email adresa",
    placeholder: "Unesite svoju email adresu",
    required: true,
    type: "email",
  },
  {
    name: "Telefonski broj",
    placeholder: "Npr. 0912345678",
    required: true,
    type: "tel",
  },
  {
    name: "Grad",
    placeholder: "Npr. Zagreb",
    required: true,
  },
  {
    name: "Poštanski broj",
    placeholder: "Npr. 10000",
    required: true,
  },
];

export const dealerList: Dealer[] = [
  {
    id: 382600,
    label: "Emil Frey Autocentar Zagreb",
    address: "Kovinska 22, 10000 Zagreb",
    badges: ["Kovinska 22", "Zagreb"],
    lat: 45.8081178,
    lng: 15.8496324,
  },
  {
    id: 382601,
    label: "AUTO MALL SPLIT d.o.o.",
    address: "Pazdigradska 2, 21000 Split",
    badges: ["Pazdigradska 2", "Split"],
    lat: 43.5095245,
    lng: 16.4915468,
  },
  // {
  //   id: 382602,
  //   label: "AUTO GAŠPARIĆ d.o.o.",
  //   address: "Velikogorička 19a, 10410 Velika Gorica",
  //   badges: ["Velikogorička 19a", "Velika Gorica"],
  // },
  // {
  //   id: 382604,
  //   label: "BAUER",
  //   address: "Prilaz Dr. Franje Tuđmana 3B, 49210 Zabok",
  //   badges: ["Prilaz Dr. Franje Tuđmana 3B", "Zabok"],
  // },
  // {
  //   id: 382606,
  //   label: "KARIĆ  AUTOMOBILI d.o.o.",
  //   address: "Ul. Andrije Žaje 5, 10000 Zagreb",
  //   badges: ["Ul. Andrije Žaje 5", "Zagreb"],
  // },
  {
    id: 382607,
    label: "PSC PRIMORJE d.o.o.",
    address: "Martinkovac 143, 51000 Rijeka",
    badges: ["Martinkovac 143", "Rijeka"],
    lat: 45.3545886,
    lng: 14.363092,
  },
  {
    id: 382609,
    label: "AC PRIKRATKI d.o.o.",
    address: "Zagrebačka ulica 101, 42000 Varaždin",
    badges: ["Zagrebačka ulica 101", "Varaždin"],
    lat: 46.2899792,
    lng: 16.3457459,
  },
  {
    id: 382610,
    label: "AUTO CENTAR DUO d.o.o.",
    address: "Sv. L. B. Mandića 31D, 31000 Osijek",
    badges: ["Sv. L. B. Mandića 31D", "Osijek"],
    lat: 45.5502485,
    lng: 18.6686657,
  },
  {
    id: 382612,
    label: "AUTO SALON TOŠ",
    address: "Zagrebačka ulica 103, 10000 Zagreb",
    badges: ["Zagrebačka ulica 103", "Zagreb"],
    lat: 45.8259139,
    lng: 16.0897603,
  },
  {
    id: 382615,
    label: "AVIA CARS d.o.o.",
    address: "Ulica 4. Gardijske Brigade 52, 23000 Zadar",
    badges: ["Ulica 4. Gardijske Brigade 52", "Zadar"],
    lat: 44.1049338,
    lng: 15.262388,
  },
];
